export default __webpack_public_path__ + "static/media/Group 12725.e13737be.svg";